<template>
  <v-autocomplete
    v-bind="$props"
    :deletable-chips="multiple"
    :outlined="outlined"
    :rules="mergedRules"
    :small-chips="multiple"
    class="flex-grow-0"
    item-text="key"
    width="auto"
    dense
    v-on="$listeners"
    @click:clear="onClear"
  />
</template>

<script>
import { VAutocomplete } from 'vuetify/lib'

export default {
  name: 'AutocompleteInput',
  extends: VAutocomplete,
  props: {
    outlined: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mergedRules() {
      const propRules = this.$props.rules || []
      const requiredRules = this.required ? [v => !!v || 'Property required!'] : []

      return [...propRules, ...requiredRules].filter(Boolean)
    },
  },
  methods: {
    onClear() {
      this.$nextTick(() => {
        this.$emit('input', undefined)
      })
    },
  },
}
</script>
